module.exports = __webpack_public_path__ + "img/placeholder-image.cdda015e.svg";